import type { ReactNode } from "react";

import { statusTokens } from "../domain/status";
import type { CompanyStatus } from "../domain/status";
import { nl } from "../i18n/nl";
import styles from "./AdviceCard.module.css";
import { StatusGlyph } from "./StatusGlyph";

export interface AdviceCardProps {
  status: CompanyStatus;
  title: string;
  text: string;
  /** Contextual actions; at most one primary button. */
  actions?: ReactNode;
  note?: string;
}

/** "Advies voor jou": advice first, data second. */
export function AdviceCard({ status, title, text, actions, note }: AdviceCardProps) {
  const { fg, bg } = statusTokens(status);
  return (
    <section className={styles.card} style={{ background: bg }} aria-label={nl.advice.label}>
      <span className={styles.icon}>
        <StatusGlyph status={status} size={18} />
      </span>
      <div className={styles.body}>
        <p className={styles.label} style={{ color: fg }}>
          {nl.advice.label}
        </p>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{text}</p>
        {actions && <div className={styles.actions}>{actions}</div>}
        {note && <p className={styles.note}>{note}</p>}
      </div>
    </section>
  );
}
